import type {DynamicPageModel} from '@/types/content';
import type {BadgeDetailsContentModel} from '@/types/content/badgeDetails';
import type {GlobalButtonsContentModel} from '@/types/content/common';

import {getContent} from './content';

export const getDynamicPages = (): DynamicPageModel[] => getContent().dynamicPagesContent?.dynamicPages ?? [];

export const getGlobalButtons = (): GlobalButtonsContentModel => getContent().globalButtons ?? {};

export const getBadgeDetailsContent = (): BadgeDetailsContentModel => getContent().badgeDetailsContent ?? {};
